<template>
  <div id="camera-error-android" class="fade-in">
    <StepInfo btnText="Recarregar página" @btnClick="refreshPage" iconName="refresh">
      <h2>Habilite o acesso à câmera</h2>
      <p>
        Para tirar a foto do documento é necessário que a câmera esteja habilitada.
      </p>

      <Asset
        name="o-camera-error-android.svg"
        alt="Barra de pesquisa do android"
        title="Barra de pesquisa do android"
      />

      <div class="tutorial-step">
        <span>1</span>
        <p>
          Toque no ícone do <b>”cadeado”</b> na barra de navegação do Chrome
        </p>
      </div>

      <div class="tutorial-step">
        <span>2</span>
        <p>
          Em seguida toque em <b>“Configurações do site”</b>
        </p>
      </div>

      <div class="tutorial-step">
        <span>3</span>
        <p>
          Em <b>”Permissões”</b>, escolha <b>”Acessar sua câmera”</b> e
          marque a opção  <b>”Permitir”</b>
        </p>
      </div>

    </StepInfo>
  </div>
</template>

<script>
import Asset from '@/components/common/Asset.vue';

import StepInfo from '../components/StepInfo.vue';

export default {
  name: 'camera-error-android',
  components: { StepInfo, Asset },
  methods: {
    refreshPage() {
      this.$router.replace({
        name: 'onboarding-main',
        query: this.$route.query,
      }).then(() => {
        this.$router.go();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #camera-error-android {
    h2 {
      color: var(--gray-600);
      margin-top: 24px;
    }

    p {
      @extend .lead;
      margin-top: 8px;
      line-height: 26px;
    }

    img {
      width: 100%;
      margin-top: 20px;
    }

    .tutorial-step {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 16px 0;

      span {
        min-width: 20px;
        min-height: 20px;

        margin-right: 8px;

        border-radius: 50%;
        background: var(--primary-washed);
        color: #fff;

        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
</style>
